var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: { "content-css": { minWidth: "25vw", minHeight: "30vh" } },
      model: {
        value: _vm.orderTypeModal.open,
        callback: function($$v) {
          _vm.$set(_vm.orderTypeModal, "open", $$v)
        },
        expression: "orderTypeModal.open"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("q-icon", { attrs: { name: "", label: "Order Type" } }),
              _c("q-toolbar-title"),
              _c("q-icon", {
                attrs: { icon: "clear" },
                nativeOn: {
                  click: function($event) {
                    _vm.onClose()
                  }
                }
              })
            ],
            1
          ),
          _c(
            "q-toolbar",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("q-toolbar-title"),
              _c("q-btn", { attrs: { label: "Add", color: "green" } })
            ],
            1
          ),
          _c("div", [_c("div", [_vm._v("\n        testing\n      ")])])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }